module.exports = "pegasus/assets/restaurant-logo.png";